import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import IndustrySolutionCard from '../../components/IndustrySolutionCard';
import SEO from '../../components/SEO';

const CreativeIndustries = () => {
  const solutions = [
    {
      icon: <i className="fi fi-ss-puzzle-pieces text-4xl"></i>,
      title: 'AI-Powered Content Generation',
      description: 'Transform creative workflows with intelligent content generation tools that enhance productivity while maintaining artistic quality and brand consistency.',
      features: [
        'Multi-format content creation (text, image, video)',
        'Brand voice and style consistency',
        'Automated asset tagging and organization',
        'Real-time collaboration and versioning'
      ]
    },
    {
      icon: <i className="fi fi-ss-puzzle-pieces text-4xl"></i>,
      title: 'Lifestyle & Social Media App Development',
      description: 'Design and build consumer-first lifestyle and social media applications focused on engagement, retention, and scalable growth.',
      features: [
        'Short-form video and feed-based UX patterns',
        'Creator and community engagement features',
        'In-app messaging, notifications, and moderation',
        'Analytics-driven growth and retention tooling'
      ]
    },
    {
      icon: <i className="fi fi-ss-puzzle-pieces text-4xl"></i>,
      title: 'Digital Asset Management',
      description: 'Centralized platform for managing, organizing, and distributing creative assets across teams and projects with intelligent search and discovery.',
      features: [
        'AI-powered image recognition and tagging',
        'Advanced search and filtering',
        'Rights and permissions management',
        'Integration with creative tools (Adobe, Figma, etc.)'
      ]
    },
    {
      icon: <i className="fi fi-ss-puzzle-pieces text-4xl"></i>,
      title: 'Game Development Solutions',
      description: 'End-to-end game product development for mobile and web, from gameplay systems to live operations.',
      features: [
        'Gameplay loop and progression system design',
        'Multiplayer, leaderboard, and social features',
        'LiveOps events, monetisation, and A/B testing',
        'Performance optimisation across target devices'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white text-gray-800">
      <SEO
        title="Creative Industries Solutions | STRAY Apps"
        description="Purpose-built digital products for creators, media teams, and entertainment platforms."
        path="/industry-solutions/creative-industries"
      />
      {/* Hero Section */}
      <section className="relative overflow-hidden py-24 bg-white">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl animate-pulse"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10">
          <div className="text-left mb-8">
            <h1 className="text-5xl sm:text-6xl font-bold bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 bg-clip-text text-transparent mb-4">
              Creative Industries Solutions
            </h1>
            <p className="text-xl text-gray-700 max-w-3xl font-light">
              Purpose-built digital products for creators, media teams, and entertainment platforms.
            </p>
          </div>
        </div>
      </section>

      {/* Solutions Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {solutions.map((solution, index) => (
              <IndustrySolutionCard
                key={index}
                icon={solution.icon}
                title={solution.title}
                description={solution.description}
                features={solution.features}
              />
            ))}
          </div>
        </div>
      </section>

     

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            Ready to Elevate Your Creative Projects?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Discover how our creative solutions can transform your production workflow.
          </p>
          <Link to="/contact">
            <button className="px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-lg text-white font-semibold text-lg transition-all hover:shadow-lg hover:shadow-purple-500/30">
              Start Creating Today
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CreativeIndustries;
